module.exports = __webpack_public_path__ + "media/images/Kitchen Espresso Cabinets sq-fa85740f.webp";